import { BaseWidgetRenderer } from './base-widget-renderer';
import { DividerWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';

export class DividerWidgetRenderer extends BaseWidgetRenderer<DividerWidgetJsonData> {
    protected get defaultData(): DividerWidgetJsonData {
        return {
            id: '',
            type: 'divider',
            thickness: 1,
            color: '#000000'
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: DividerWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const divider = document.createElement('hr');
        divider.classList.add('divider-element');

        if (widgetJsonData.thickness) {
            divider.style.borderWidth = `${widgetJsonData.thickness}px`;
        }

        if (widgetJsonData.color) {
            divider.style.borderColor = widgetJsonData.color;
        }

        content.appendChild(divider);
        return content;
    }
}
